import React from 'react'

type CardTitleProps = {
  title: string
  subtitle: string
  children?: React.ReactNode
  className?: string
  subtitleClassName?: string
}

const CardTitle: React.FC<CardTitleProps> = ({
  title,
  subtitle,
  children,
  className = 'w-[338px] min-w-[338px]',
  subtitleClassName = 'w-full',
}) => (
  <div className={`${className} h-full relative`}>
    <h2 className="absolute top-1/2 -translate-y-full text-4xl font-semibold leading-10 text-brand whitespace-nowrap">
      {title}
    </h2>
    <p className={`absolute top-1/2 mt-2 text-sm font-normal leading-5 text-gray-dark ${subtitleClassName}`}>
      {subtitle}
    </p>
    {children && (
      <div className="absolute bottom-0 w-full">
        {children}
      </div>
    )}
  </div>
)

export default CardTitle
